import zod from 'zod';
import { stringToListOfNumber, zodLimit, zodPage } from './helpers';

export const vacancyStatus = [
    'scheduled',
    'opened',
    'confirmed',
    'progress',
    'finished',
    'canceled',
] as const;
export type VacancyStatus = typeof vacancyStatus[number];

export const applicationStatus = [
    'approved',
    'progress',
    'confirmed',
    'finished',
    'canceled',
] as const;
export type ApplicationStatus = typeof applicationStatus[number];

export const DeacSchemas = {
    Dashboard: zod.object({
        beginIn: zod.coerce.number().optional(),
        endIn: zod.coerce.number().optional(),
    }),
    VacancyLevels: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
        actingBodyId: zod.coerce.number().optional(),
    }),
    Workplaces: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
        actingBodyId: zod.coerce.number().optional(),
        actingBodyUnitId: zod.coerce.number().optional(),
        actingBodyCommandId: zod.coerce.number().optional(),
    }),
    VacancyTags: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
    }),
    VacancyCancellationReasons: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
    }),
    Vacancies: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
        actingBodyId: zod.coerce.number().optional(),
        actingBodyUnitId: zod.coerce.number().optional(),
        actingBodyCommandId: zod.coerce.number().optional(),
        status: zod.enum(vacancyStatus).optional(),
        levelsIds: stringToListOfNumber.optional(),
        tagsIds: stringToListOfNumber.optional(),
        createdBy: zod.coerce.number().optional(),
        beginIn: zod.coerce.number().optional(),
        endIn: zod.coerce.number().optional(),
    }),
    VacancyForm: zod.object({
        id: zod.coerce.number().optional(),
    }),
    PresenceControl: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
        workplaceId: zod.coerce.number().optional(),
        actingBodyId: zod.coerce.number().optional(),
        actingBodyUnitId: zod.coerce.number().optional(),
        vacancyActingBodyId: zod.coerce.number().optional(),
        vacancyActingBodyCommandId: zod.coerce.number().optional(),
        vacancyActingBodyUnitId: zod.coerce.number().optional(),
        registeredBy: zod.coerce.number().optional(),
        changedBy: zod.coerce.number().optional(),
        beginIn: zod.coerce.number().optional(),
        endIn: zod.coerce.number().optional(),
    }),
    DeacReports: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
        actingBodyId: zod.coerce.number().optional(),
    }),
    Applications: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
        actingBodyId: zod.coerce.number().optional(),
        actingBodyUnitId: zod.coerce.number().optional(),
        actingBodyCommandId: zod.coerce.number().optional(),
        status: zod.enum(applicationStatus).optional(),
        userId: zod.coerce.number().optional(),
    }),
    VacanciesTemplates: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
        actingBodyId: zod.coerce.number().optional(),
        actingBodyUnitId: zod.coerce.number().optional(),
        actingBodyCommandId: zod.coerce.number().optional(),
        levelsIds: stringToListOfNumber.optional(),
        tagsIds: stringToListOfNumber.optional(),
    }),
    VacancyTemplateForm: zod.object({
        id: zod.coerce.number().optional(),
    }),
};
